import post from './post.js';
import get from './get.js';

export default {
	data: ({session}) => get('910/data',{session}),
	delete: ({ session, ip, name }) => post('910/delete', { session, ip, name }),
	delete_all: ({ session, ip }) => post('910/delete_all', { session, ip })
};
